import{KibTransition}from"./kib-transition";export default KibTransition;